import { createApp, defineAsyncComponent } from 'vue';
import App from './App.vue';

//Google Login
import vue3GoogleLogin from 'vue3-google-login'

// Vuetify
import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
//icons
import 'material-design-icons-iconfont/dist/material-design-icons.css';
import { aliases, md } from 'vuetify/iconsets/md'


//i18n
import { createI18n, useI18n } from 'vue-i18n';
import eng from './locales/en.json';
import esp from './locales/es.json';
import mlt from './locales/mt.json';
import { es, en } from 'vuetify/locale'

// Get saved language from localStorage or default to English
const getSavedLanguage = () => {
  const saved = localStorage.getItem('app_language');
  if (saved && (saved === 'en' || saved === 'es' || saved === 'mt')) {
    return saved;
  }
  return 'en'; // Default to English
};

const i18n = createI18n({
  locale: getSavedLanguage(),
  fallbackLocale: 'en',
  messages: {
    en: {
      ...eng,
      $vuetify: {
        ...en,
        dataIterator: {
          rowsPerPageText: 'Items per page:',
          pageText: '{0}-{1} of {2}',
        },
      },
    },
    es: {
      ...esp,
      $vuetify: {
        ...es,
        dataIterator: {
          rowsPerPageText: 'registro ejemplo:',
          pageText: '{0}-{1} of {2}',
        },
      },
    },
    mt: {
      ...mlt,
      $vuetify: {
        ...en,
        dataIterator: {
          rowsPerPageText: 'Rekords għal kull paġna:',
          pageText: '{0}-{1} minn {2}',
        },
      },
    },
  },
});

import { createVueI18nAdapter } from 'vuetify/locale/adapters/vue-i18n'

const vuetify = createVuetify({
  icons: {
    defaultSet: 'md',
    aliases,
     sets: {
       md,
     },
  },
  locale:{
    adapter: createVueI18nAdapter({ i18n, useI18n})
  },
  components,
  directives,
});

//router
import router from "./router.js";
//Store
import store from "./store/index.js";


// ----------------- FIREBASE INIT -------------------------------------------------
import firebase from "firebase/compat/app";
//VUE_APP_FIREBASE_DB_URL maybe we need this variable
var firebaseConfig = {
    apiKey: process.env.VUE_APP_FIREBASE_APY_KEY,
    authDomain: process.env.VUE_APP_FIREBASE_AUTH_DOMAIN,
    projectId: process.env.VUE_APP_FIREBASE_PROJECT_ID,
    storageBucket: process.env.VUE_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.VUE_APP_FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env.VUE_APP_FIREBASE_APP_ID,
  };
// Initialize Firebase
firebase.initializeApp(firebaseConfig);
// ----------------- FIREBASE END --------------------------------------------------

//Service Worker for PWA
import './registerServiceWorker';

// Ui Components
//TODO: We have to change this for login page - another comment to deploy 
const BaseCard = defineAsyncComponent(() => import('./components/ui/BaseCard.vue'));
const BaseButton = defineAsyncComponent(() => import('./components/ui/BaseButton.vue'));
const BaseBadge = defineAsyncComponent(() => import('./components/ui/BaseBadge.vue'));
const ButtonFloat = defineAsyncComponent(() => import('./components/ui/ButtonFloat.vue'));
const BaseSpinner = defineAsyncComponent(() => import('./components/ui/BaseSpinner.vue'));
const BaseDialog = defineAsyncComponent(() => import('./components/ui/BaseDialog.vue'));
const QrScannerModal = defineAsyncComponent(() => import('./components/ui/QrScannerModal.vue'));

// Suppress the benign "ResizeObserver loop" warning that webpack-dev-server's
// overlay incorrectly surfaces as a fatal error. The browser fires this when
// it can't deliver all ResizeObserver notifications in a single animation frame,
// which is harmless. stopImmediatePropagation() prevents the overlay listener
// from ever receiving the event.
// Suppress the benign "ResizeObserver loop" warning that webpack-dev-server's
// overlay incorrectly surfaces as a fatal error. capture:true runs this in the
// capture phase, before the overlay's bubble-phase listener, so
// stopImmediatePropagation() actually prevents it from reaching the overlay.
window.addEventListener('error', (e) => {
  if (e.message && e.message.includes('ResizeObserver loop')) {
    e.stopImmediatePropagation();
  }
}, true);

const app = createApp(App);
app.use(router);
app.use(store);
app.use(vuetify);
app.use(i18n);

// Initialize language from store (loads saved language or defaults to English)
store.dispatch('language/initializeLanguage');

// Sync initial language with i18n after initialization
const savedLanguage = store.getters['language/getCurrentLanguage'];
if (i18n.global.locale !== savedLanguage) {
  i18n.global.locale = savedLanguage;
}

// Watch for language changes in store and update i18n
store.watch(
  (state) => state.language.currentLanguage,
  (newLanguage) => {
    if (i18n.global.locale !== newLanguage) {
      i18n.global.locale = newLanguage;
    }
  }
);

app.component('base-card', BaseCard);
app.component('base-button', BaseButton);
app.component('base-badge', BaseBadge);
app.component('button-float', ButtonFloat);
app.component('base-spinner', BaseSpinner);
app.component('base-dialog', BaseDialog);
app.component('qr-scanner-modal', QrScannerModal);

app.use(vue3GoogleLogin, {
  clientId: process.env.VUE_APP_GOOGLE_CLIENT_ID
});

// Suppress the benign "ResizeObserver loop" browser warning that
// webpack-dev-server's overlay incorrectly surfaces as a fatal error.
// capture:true runs before the overlay's bubble-phase listener.
window.addEventListener('error', (e) => {
  if (e.message && e.message.includes('ResizeObserver loop')) {
    e.stopImmediatePropagation();
  }
}, true);

app.mount('#app')
